import { lazyComponent } from "../../../lazy";
import { WIDGET_PANEL_ID, DIAGNOSTIC_WIDGET_ID } from "./dashboardUtils";
// ── Built-in standard widgets ──────────────────────────────────────────────
// Shipped with UXP Core and available on every dashboard without any additional
// bundles. The backend never returns these (no marketplace bundle), so they are
// the single source of truth for both registration (rendering) and drawer injection.
const WidgetPanel = lazyComponent(() => import(/* webpackChunkName: "dashboard" */ "@core/dashboard/panel-widget/WidgetPanel"));
const DiagnosticWidget = lazyComponent(() => import(/* webpackChunkName: "dashboard" */ "@core/dashboard/diagnostic-widget/DiagnosticWidget"));
export const BUILTIN_WIDGETS = [
    {
        id: WIDGET_PANEL_ID,
        name: 'Widget Panel',
        description: 'A nested dashboard panel that embeds a full grid of widgets inside another widget. Use it to create composite layouts, tabs-within-dashboards, or multi-column arrangements within a single dashboard cell.',
        icon: 'fas layer-group',
        component: WidgetPanel,
        modes: ['widget'],
        tags: ['uxp-core', 'standard', 'layout', 'dashboard'],
        vendor: 'UXP Core',
        configs: {
            props: [
                {
                    name: 'orientation',
                    label: 'Orientation',
                    type: 'select',
                    value: 'vertical',
                    options: [
                        { label: 'Vertical', value: 'vertical' },
                        { label: 'Horizontal', value: 'horizontal' }
                    ]
                },
                {
                    name: 'columns',
                    label: 'Columns',
                    type: 'number',
                    value: 30,
                    show: (data) => data.orientation === 'vertical'
                },
                {
                    name: 'rows',
                    label: 'Rows',
                    type: 'number',
                    value: 20,
                    show: (data) => data.orientation === 'horizontal'
                },
            ]
        },
        defaultProps: {
            columns: 30,
            orientation: 'vertical',
            rows: 20
        }
    },
    {
        id: DIAGNOSTIC_WIDGET_ID,
        name: 'Diagnostic',
        description: 'A standard debugging widget that renders all props and URL search params it receives in table form. Drop it on any dashboard or view to inspect what data is being passed — useful for development and troubleshooting.',
        icon: 'fas bug',
        component: DiagnosticWidget,
        modes: ['widget'],
        tags: ['uxp-core', 'standard', 'diagnostic', 'debug'],
        vendor: 'UXP Core',
        configs: {
            layout: { w: 20, h: 14, minW: 8, minH: 6 }
        }
    }
];
// Register for rendering (lookupComponent / window.Components) at boot.
BUILTIN_WIDGETS.forEach(w => window.registerComponent(w));
